import { unnull } from '@/shared/lib/converters.ts';
import type { TTourFiltersState } from '@/entities/filter/store/types/tour/state';
import type { LocationQueryRaw } from 'vue-router';
import { DEFAULT_SORTING } from '@/entities/filter/store/const/config.ts';

export const tourBuildQueryFilterParams = (searchState: TTourFiltersState): LocationQueryRaw => {
  const typeParam = searchState.tourFormat?.length ? Array.from(new Set(searchState.tourFormat)).join(',') : undefined;

  return {
    end_date: unnull(searchState.date.to),
    end_duration: unnull(searchState.duration[1]),
    end_price: unnull(searchState.price[1]),
    tours_activities: searchState.toursActivities?.length ? searchState.toursActivities.join(',') : undefined,
    persons_count: searchState.persons > 1 ? searchState.persons : undefined,
    start_date: unnull(searchState.date.from),
    start_duration: unnull(searchState.duration[0]),
    start_price: unnull(searchState.price[0]),
    type: typeParam,
    children_allowed: searchState.childrenAllowed ? String(searchState.childrenAllowed) : undefined,
    comfort_type: searchState.comfort_type?.length ? searchState.comfort_type.join(',') : undefined,
    activity_level_category: searchState.activity_level_category?.length
      ? searchState.activity_level_category.join(',')
      : undefined,
    accommodation_type: searchState.accommodation_type?.length ? searchState.accommodation_type.join(',') : undefined,
    sorting: searchState.sorting !== DEFAULT_SORTING ? unnull(searchState.sorting) : undefined,
  };
};
